import React, { useState, useEffect, useRef } from "react";
import { useTheme, styled } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from "prop-types";
import {
  Grid,
  Typography,
   
  Button,
   
  
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { format, isValid } from 'date-fns';
import { useTranslation } from "react-i18next";
//get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "entry-of-the-results-of-the-various-assessments-for-the-patients";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          className="float-end"
          size="large">
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const LabTestAppointmentModal = ({ handleClose, open, addTestAppointment, FacilityId, TestToFacilityId, ...props }) => {

  const { t } = useTranslation();

  /* console.log("Modalprops ",props.formData.PatientId); */

  const tblLotRefHolder = useRef({ table: null });
  const tblLotRef = tblLotRefHolder.current;
  const ItemGroupId = props.formData.ItemGroupId;
  const PatientId = props.formData.PatientId;

  const [tabledata, setTabledata] = useState([]); 
  const { isLoading, error, isError, data, refetch } = useQuery(
    ["lab-test-list", FacilityId, PatientId, ItemGroupId, TestToFacilityId],
    () =>
      api
        .getLabTestAppointmentModalList(
          FacilityId,
          PatientId,
          ItemGroupId,
          TestToFacilityId
        )
        .then((rows) => {
          const list = Array.isArray(rows) ? rows : [];
          setTabledata(list);
          return list;
        }),
    {
      enabled: Boolean(
        FacilityId && PatientId && ItemGroupId && TestToFacilityId
      ),
    }
  );



  const [selectedProducts, setselectedProducts] = useState([]);

  const [errorMessage, setErrorMessage] = useState("");
  

  const ProductColumns = [
    { title: "id", field: "id", visible: false },
    { title: "PatientId", field: "PatientId", visible: false },
    { title: "TestId", field: "TestId", visible: false },
    { title: "TestAppointmentId", field: "TestAppointmentId", visible: false },
   
    { title: t(DispensingLanguage[lan][menukey]['Sl#']),  formatter: "rownum", width:45, hozAlign: "center" , headerHozAlign:"center", headerSort:false},
    { title: t(DispensingLanguage[lan][menukey]['Register#']), width:110, field: "idNumber", headerFilter:true  },
    { title: t(DispensingLanguage[lan][menukey]['Last Name']), width:60, field: "lastName", headerFilter:false, visible: false  },
    { title: t(DispensingLanguage[lan][menukey]['First Name']), width:60, field: "firstName", headerFilter:false, visible: false  },
    { title: t(DispensingLanguage[lan][menukey]['Contact#']), width:80,  field: "contactNumber", headerFilter:false  },
    {
      title: t(DispensingLanguage[lan][menukey]["DoB"]),
      field: "dob",
      width: 80,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        let date = value ? new Date(value) : null;
        if (!date || !isValid(date)) {
          return "";
        }
        return format(date, 'dd/MM/yyyy');
      },
    },
    
    { title: t(DispensingLanguage[lan][menukey]['Gender']), width:80, field: "GenderTypeId", headerFilter:true  },
   
    {
      title: t(DispensingLanguage[lan][menukey]["Appointment Date"]),
      field: "TransactionDate",
      width: 120,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        let date = value ? new Date(value) : null;
        if (!date || !isValid(date)) {
          return "";
        }
        return format(date, 'dd/MM/yyyy');
      },
    },
   
    { title: t(DispensingLanguage[lan][menukey]['Test Name']), field: "TestName", headerFilter:true, minWidth: 100},
    { title: t(DispensingLanguage[lan][menukey]['Test Unit']), field: "UnitName", headerFilter:true ,  width: 100 },
   
  ];


  
  const ProdustDataItemsLot = tabledata?.map((item, index) => { 
    return item;
  });

  let filteredDataItemsLot;

  if (PatientId) {
    filteredDataItemsLot = ProdustDataItemsLot.filter(item => item.PatientId === PatientId);
  } else {
    filteredDataItemsLot = ProdustDataItemsLot;
  }

  let selectedRows = [];
  
  const [btnDisable, setbtnDisable] = useState(false);

/*   const SaveSelectedProducts = () => { 
    if(tblLotRef.table.getSelectedData().length>0){
      setbtnDisable(true);
      selectedRows = tblLotRef.table.getSelectedData();
     addTestAppointment(tblLotRef.table.getSelectedData());  
      setTimeout(() => setbtnDisable(false), 500);
    }  
  }; */


  const SaveSelectedProducts = () => { 
    if(tblLotRef.table.getSelectedData().length>0){

      selectedRows = tblLotRef.table.getSelectedData();

     
      const patientIds = new Set();
      let hasDifferentPatientIds = false;
  
      for (const row of selectedRows) {
        if (patientIds.has(row.PatientId)) {
          continue;
        }
  
        patientIds.add(row.PatientId);
  
        if (patientIds.size > 1) {
          hasDifferentPatientIds = true;
          break;
        }
      }
  
      if (hasDifferentPatientIds) {
        setErrorMessage(t(DispensingLanguage[lan][menukey]["Select single patinet appointment"]));
        return;
      } else {
        setErrorMessage(""); 
      }


      setbtnDisable(true);
      addTestAppointment(tblLotRef.table.getSelectedData());  
      setTimeout(() => setbtnDisable(false), 500);
    }  
  }; 
  


  const checkSelect = (row) => { 
    console.log(row);
    console.log("row");
  };

  useEffect(() => {
    if (tblLotRef.table == null) return;



}, []);
  return (
    <div>
      <BootstrapDialog
        onClose={() => handleClose('TestAppointmentClose')}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth="md" 
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => handleClose('TestAppointmentClose')}
        >
          {t(DispensingLanguage[lan][menukey]['Appointment Test List'])}
          {/* {DispensingLanguage[lan][menukey]['Patient List']} */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <ReactTabulator
            onRef={(rf) => { tblLotRef.table = rf.current; }}
            options={{
              selectableRowsRangeMode: 'click',
              selectableRows: true,
             }}
            columns={ProductColumns}
            /* data={ProdustDataItemsLot} */
            data={filteredDataItemsLot}
            height="300px"
            layout={"fitColumns"}
            //selectableCheck={(row)=>checkSelect(row)}


          />
        </DialogContent>
        <DialogActions>

        <Typography
              variant="body2"
              component="p"
              className="sw_text_label text-danger"
            >
              {  errorMessage }
        </Typography>


          <Button
            disabled={btnDisable}
            className="me-2 float-start"
            variant="contained"
            color="primary"
            onClick={SaveSelectedProducts}
          >
            {t(DispensingLanguage[lan][menukey]['ADD'])}  
          </Button>
          <Button
            autoFocus
            className="float-start"
            variant="contained"
            color="gray"
            onClick={() => handleClose('TestAppointmentClose')}
          >
           {t(DispensingLanguage[lan][menukey]['CANCEL'])}   
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default LabTestAppointmentModal;

const useStyles = makeStyles({
  fullWidth: {
    width: "100%",
  },
});